import { useQuery, useMutation } from "@tanstack/react-query";
import candidateService from "../Service.js/CandidateService";

export const FETCH_ALL_DOCUMENTS = "FETCH_ALL_DOCUMENTS";
export const useFetchCandidateDocuments = (config) => {
  const { params, ...rest } = config;
  const query = useQuery({
    queryKey: [FETCH_ALL_DOCUMENTS, params?.candidate_id],
    queryFn: async () => {
      const { job_id = null, candidate_id = null } = params;
      const response = await candidateService.getDocuments(
        job_id,
        candidate_id
      );
      return response?.data?.data;
    },
    refetchOnWindowFocus: false,
    ...rest,
  });
  return query;
};

/* 
  Fetches all supported documents types
*/
export const FETCH_ALL_DOCUMENTS_TYPES = "FETCH_ALL_DOCUMENTS_TYPES";
export const useFetchAllDocumentTypes = (config) => {
  const { params, ...rest } = config;
  const query = useQuery({
    queryKey: [FETCH_ALL_DOCUMENTS_TYPES, params?.job_id],
    queryFn: async () => {
      const response = await candidateService.getDocumentTypes(params);
      return response?.data?.data;
    },
    refetchOnWindowFocus: false,
    ...rest,
  });
  return query;
};

/* 
  Deletes a Candidate's document.
*/
export const useDeleteChosenDocument = (config) => {
  const mutation = useMutation({
    mutationFn: async ({ id, params }) => {
      const details = await candidateService.deleteChosenDocument(id, params);
      return details?.data;
    },
    ...config,
  });
  return mutation;
};
